import { render, staticRenderFns } from "./ReportSales.vue?vue&type=template&id=72dca22c&scoped=true&"
import script from "./ReportSales.vue?vue&type=script&lang=js&"
export * from "./ReportSales.vue?vue&type=script&lang=js&"
import style0 from "./ReportSales.vue?vue&type=style&index=0&id=72dca22c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dca22c",
  null
  
)

export default component.exports